<div class="coc-sample-grid tableColStyle custom-theme-table">
  <div class="custom-scrollbar sticky-header table-shadow h-auto">
    <table mat-table [dataSource]="localDataSource" class="h-100 table table-striped">
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center" [attr.colspan]="displayedColumns?.length || 1">
          <b>{{'No samples available' | translate}}</b>
        </td>
      </tr>

      <!-- Checkbox Column (only when showCheckboxes is true and not in final step for selection) -->
      @if (showCheckboxes && !isFinalStep) {
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="toggleAll($event.checked)"
              [checked]="isAllSelected()"
              [indeterminate]="selectedSamples.length > 0 && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (change)="toggleSelection(row, $event.checked)"
              [checked]="isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
      }

      <!-- Sample Number Column with Barcode support -->
      <ng-container matColumnDef="sampleNumber">
        <th class="left-aligned" mat-header-cell *matHeaderCellDef>{{'Sample Number' | translate}}</th>
        <td class="left-aligned cursor-pointer" mat-cell *matCellDef="let element" (click)="onSampleClick(element)">
          @if (isFinalStep && hasBarcodeContent(element)) {
            <div class="d-flex justify-content-center">{{element.sampleNumber}}</div>
            <div class="barcode-container">
              <app-barcode [value]="getBarcodeContent(element)"></app-barcode>
            </div>
          } @else {
            {{ element.sampleNumber || '-' }}
          }
        </td>
      </ng-container>

      <!-- Agent Name Column -->
      <ng-container matColumnDef="masterAgentName">
        <th class="left-aligned" mat-header-cell *matHeaderCellDef>{{'Agent Name' | translate}}</th>
        <td mat-cell *matCellDef="let element" class="multiple-data-border">
          @for (result of (element.ihLabResults || []); track trackById($index, result)) {
            <div>
              {{ result.masterAgentName || '-' }}
            </div>
          }
        </td>
      </ng-container>

      <!-- Agent Group Column -->
      <ng-container matColumnDef="agentGroupId">
        <th mat-header-cell *matHeaderCellDef>{{'Agent Group' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{ element.agentGroupName || getCellValue(element, 'agentGroupId') }}</td>
      </ng-container>

      <!-- Sampling Date Column -->
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef>{{'Sampling Date' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{ element.startDate | dateFormat }}</td>
      </ng-container>

      <!-- Sample Volume Column -->
      <ng-container matColumnDef="sampleVolume">
        <th mat-header-cell *matHeaderCellDef>{{'Sample Volume' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{ element.sampleVolume }}</td>
      </ng-container>

      <!-- Run Time Column -->
      <ng-container matColumnDef="runTime">
        <th mat-header-cell *matHeaderCellDef>{{'Total Time (Minutes)' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{ element.runTime }}</td>
      </ng-container>

      <!-- Flowrate Column -->
      <ng-container matColumnDef="flowRate">
        <th mat-header-cell *matHeaderCellDef>{{'Flowrate' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{ element.flowRate }}</td>
      </ng-container>

      <!-- Method Reference Column -->
      <ng-container matColumnDef="analyticalMethodName">
        <th mat-header-cell *matHeaderCellDef>{{'Method Reference' | translate}}</th>
        <td mat-cell *matCellDef="let element">{{ element.analyticalMethodName || '-' }}</td>
      </ng-container>

      <!-- Dynamic columns from grid view settings -->
      @for (column of gridViewColumns; track trackByIndex($index)) {
        @if (!isBuiltInColumn(column.property)) {
          <ng-container [matColumnDef]="column.property">
            <th mat-header-cell *matHeaderCellDef>{{ column.displayName | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ getCellValue(element, column.property) }}</td>
          </ng-container>
        }
      }

      <tr mat-header-row *matHeaderRowDef="getDisplayColumns()"></tr>
      <tr mat-row *matRowDef="let row; let even = even; columns: getDisplayColumns();" [class.even-row]="even"></tr>
    </table>
  </div>
</div>
